import { render, staticRenderFns } from "./ScreenNavArrow.vue?vue&type=template&id=601328f3&scoped=true&"
import script from "./ScreenNavArrow.vue?vue&type=script&lang=js&"
export * from "./ScreenNavArrow.vue?vue&type=script&lang=js&"
import style0 from "./ScreenNavArrow.vue?vue&type=style&index=0&id=601328f3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601328f3",
  null
  
)

export default component.exports